"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _hotspot = require("../../hotspot.defaultConfigs");

var _speechBubble = require("./speech-bubble.styles");

var _svgElements = require("../../components/svg-elements");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var SpeechBubble = function SpeechBubble(_ref) {
  var config = _ref.config,
      iconPosition = _ref.iconPosition,
      name = _ref.name,
      onClick = _ref.onClick,
      previewHoverState = _ref.previewHoverState,
      disableHover = _ref.disableHover;
  var speechBubbleConfig = config || _hotspot.speechBubble;
  var backgroundColor = speechBubbleConfig.backgroundColor,
      color = speechBubbleConfig.color,
      hoverStyle = speechBubbleConfig.hoverStyle,
      iconColor = speechBubbleConfig.iconColor;
  var ariaLabel = "".concat(name, " hotspot");
  return _react.default.createElement(_speechBubble.ClickableAreaStyled, {
    hoverStyle: hoverStyle,
    onClick: onClick,
    previewHoverState: previewHoverState,
    disableHover: disableHover,
    "aria-label": ariaLabel
  }, iconPosition && _react.default.createElement(_speechBubble.SpeechBubbleStyled, {
    config: speechBubbleConfig,
    iconPosition: iconPosition
  }, _react.default.createElement(_speechBubble.Text, {
    color: color
  }, name), _react.default.createElement(_speechBubble.Icon, {
    iconColor: iconColor,
    viewBox: "0 0 74 74",
    preserveAspectRatio: "xMinYMin"
  }, _react.default.createElement(_svgElements.Path, {
    strokeWidth: "2",
    strokeOpacity: "1",
    d: "M 74,33 74,41 41,41 41,74 33,74 33,41 0,41 0,33 33,33 33,0 41,0 41,33 z"
  })), _react.default.createElement(_speechBubble.SpeechBubbleTail, {
    viewBox: "0 0 100 50"
  }, _react.default.createElement(_speechBubble.SpeechBubbleTailPolygon, {
    points: "30,0 0,50 100,0",
    backgroundColor: backgroundColor
  }))));
};

var _default = SpeechBubble;
exports.default = _default;